import React, { useEffect, useState } from "react";
import Header from "components/Headers/Header";
import {
  Container,
  Input,
  Button,
  Form,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Card
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import firebase from "config/firebase";
import {
  createComplaint,
  updateComplaint,
  getIssues,
  deleteIssue
} from "store/actions/athleteActions";
import moment from "moment";
import ReuseableTable from "components/Tables/ReuseableTable";
import { toast } from "react-toastify";

function ComplaintForm() {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.auth);
  const { issues, lastDocument, hasMoreDocument, complaintLoader } =
    useSelector((state) => state.athlete);
  const [issue, setIssue] = useState("");
  const [issueUpdated, setIssueUpdated] = useState("");
  const [issuesUpdateId, setIssueUpdateId] = useState("");
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateIssueLoading, setUpdateIssueLoading] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const toggle = () => {
    setModal(!modal);
    setIssue("");
  };
  const toggleUpdate = () => {
    setEditModal(!editModal);
  };

  const IssueUpdate = (data) => {
    setIssueUpdateId(data.id);
    setIssueUpdated(data.message);
    setEditModal(true);
  };

  const handleCreateIssue = (e) => {
    e.preventDefault();
    let obj = {
      message: issue,
      created_at: firebase.firestore.Timestamp.now(),
      issue_by: uid,
      issue_id: Math.floor(Math.random() * 10000) + 1000,
      issue_from: "Player",
      status: "submitted"
    };
    dispatch(
      createComplaint(obj, () => {
        dispatch(getIssues(uid, "", () => {}));
        toggle();
        setIssue("");
      })
    );
  };

  const handleUpdateIssue = (e) => {
    e.preventDefault();
    let obj = {
      message: issueUpdated,
      created_at: firebase.firestore.Timestamp.now(),
      issue_by: uid,
      issue_id: Math.floor(Math.random() * 10000) + 1000,
      issue_from: "Player",
      status: "submitted"
    };
    setUpdateIssueLoading(true);
    dispatch(
      updateComplaint(obj, issuesUpdateId, () => {
        setUpdateIssueLoading(false);
        toggleUpdate();
        setIssueUpdated("");
        dispatch(getIssues(uid, "", () => {}));
      })
    );
  };

  const deleteToggle = (issue) => {
    setSelectedRequest(issue);
    setDeleteModal(true);
  };

  const handleDeleteIssue = () => {
    if (!selectedRequest) return;
    setDeleteLoader(selectedRequest.id);
    dispatch(
      deleteIssue(selectedRequest.id, () => {
        dispatch(
          getIssues(uid, "", () => {
            setDeleteLoader(null);
            setDeleteModal(false);
            setSelectedRequest(null);
          })
        );
      })
    );
  };

  const loadMore = () => {
    setLoadMoreLoader(true);
    dispatch(
      getIssues(uid, lastDocument, () => {
        setLoadMoreLoader(false);
      })
    );
  };

  const columns = ["Issue Id", "Message", "Created at"];

  const keyMap = {
    "Issue Id": "Issueid",
    Message: "message",
    "Created at": "createdAt"
  };

  useEffect(() => {
    if (React.isValidElement(issueUpdated)) {
      setIssueUpdated(issueUpdated.props.children || "");
    }
  }, [issueUpdated]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderActions = (d) => {
    return (
      <>
        <Button
          disabled={deleteLoader === d.id}
          className="btn-primary m-1 text-white bg-primary pointer"
          size="sm"
          onClick={() => IssueUpdate(d)}
        >
          Edit
        </Button>
        <Button
          disabled={deleteLoader === d.id}
          className="btn-primary m-1 text-white bg-danger pointer"
          size="sm"
          onClick={() => deleteToggle(d)}
        >
          Delete
        </Button>
      </>
    );
  };

  useEffect(() => {
    if (issues.length == 0) {
      setIsLoading(true);
      dispatch(
        getIssues(uid, "", () => {
          setIsLoading(false);
        })
      );
    }
  }, []);

  return (
    <>
      <Header />

      <Container className="mt--4" fluid>
        <Card className="p-3">
          <div className="d-flex my-3">
            <p
              className="text-dark auth-desc-subtitle ml-0 mb-0 mt-2"
              style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
            >
              Issues
            </p>
            <Button className="ml-auto" color="primary" onClick={toggle}>
              Raise an Issue
            </Button>
          </div>
          {isLoading && (
            <div className="custom-table-body p-3 d-flex justify-content-center mb-3">
              <Spinner size={"md"} color="primary" />
            </div>
          )}
          {!isLoading && (
            <ReuseableTable
              columns={columns}
              data={issues?.map((items) => ({
                ...items,
                Issueid: items?.issue_id,
                message: (
                  <div
                    className="d-inline-block text-wrap w-100"
                    style={{ maxWidth: "500px" }}
                  >
                    {items?.message}
                  </div>
                ),
                createdAt: moment
                  .unix(items?.created_at.seconds)
                  .format("MMMM D, YYYY")
              }))}
              keyMap={keyMap}
              renderActions={renderActions}
            />
          )}
          {!isLoading && (
            <div className="w-100  p-3 d-flex justify-content-center">
              {issues.length > 4 && (
                <div className="text-center">
                  <Button
                    color="primary"
                    onClick={loadMore}
                    disabled={!hasMoreDocument || loadMoreLoader}
                  >
                    {loadMoreLoader ? <Spinner size="sm" /> : " Load more"}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Card>

        {/* Edit Modal */}
        <Modal isOpen={editModal}>
          <ModalHeader>Update Issue</ModalHeader>
          <ModalBody>
            <Form onSubmit={handleUpdateIssue}>
              <>
                <p className="auth-desc-subtitle mt-0 ml-0">
                  Please write down your issue
                </p>
                <Input
                  required
                  value={issueUpdated}
                  onChange={(e) => setIssueUpdated(e.target.value)}
                  type="textarea"
                  rows="9"
                  className="complaint-input mt-4"
                  placeholder="Write your issue..."
                />
                <div className="text-right">
                  <Button
                    disabled={!issueUpdated || updateIssueLoading}
                    color="primary"
                    size="md"
                    className="mt-4"
                    type="submit"
                  >
                    {updateIssueLoading ? <Spinner size="sm" /> : "Update"}
                  </Button>
                  <Button
                    className="mt-4"
                    color="danger"
                    onClick={toggleUpdate}
                    disabled={updateIssueLoading}
                  >
                    Close
                  </Button>
                </div>
              </>
            </Form>
          </ModalBody>
        </Modal>

        {/* Modal */}
        <Modal isOpen={modal}>
          <ModalHeader>Submit Issue</ModalHeader>
          <ModalBody>
            <Form onSubmit={handleCreateIssue}>
              <>
                <p className="auth-desc-subtitle mt-0 ml-0">
                  Please write down your issue
                </p>
                <Input
                  required
                  value={issue}
                  onChange={(e) => setIssue(e.target.value)}
                  type="textarea"
                  rows="9"
                  className="complaint-input mt-4"
                  placeholder="Write your issue..."
                />
                <div className="text-right">
                  <Button
                    disabled={!issue || complaintLoader}
                    color="primary"
                    size="md"
                    className="mt-4"
                    type="submit"
                  >
                    {complaintLoader ? <Spinner size="sm" /> : "Send"}
                  </Button>
                  <Button
                    className="mt-4"
                    color="danger"
                    onClick={toggle}
                    disabled={complaintLoader}
                  >
                    Close
                  </Button>
                </div>
              </>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={deleteModal} centered>
          <ModalBody>
            <div className="text-center">
              <p className="mt-3" style={{ fontSize: 24 }}>
                Are you sure?
              </p>
              <p style={{ fontSize: 16 }}>You want to delete this request.</p>
              <Button
                color="primary"
                onClick={() => setDeleteModal(false)}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                color="danger"
                onClick={handleDeleteIssue}
                disabled={deleteLoader === selectedRequest?.id}
              >
                {deleteLoader === selectedRequest?.id ? (
                  <Spinner size="sm" />
                ) : (
                  "Delete"
                )}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
}

export default ComplaintForm;
